module.exports = __webpack_public_path__ + "img/recognition.0bc2ecf2.png";